import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SidenavComponent } from "./shared/components/sidenav/sidenav.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { GlobalLoadingService } from "@core/services/common/global-loading.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet, SidenavComponent, MatProgressSpinnerModule],
})
export class AppComponent {
  public title = "condor-mantenimiento-webapp";
  private readonly globalLoadingService = inject(GlobalLoadingService);
  public readonly isLoading = this.globalLoadingService.isLoading;
}
